import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnErrorIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    requestAccount as requestAccountApi,
    RequestAccountApiParameter,
    RequestAccountModel,
} from "@stoneage/App/Services/RequestAccount/RequestAccountService";
import { xGoogleAnalyticsState } from "@stoneage/App/Store/Reducers";
import { getDataLayer, trackAsImpersonation } from "@stoneage/App/Utilities/DataLayer";

export interface RequestAccountParameter {
    email: string;
    firstName: string;
    lastName: string;
    companyName: string;
    customerNumber?: string;
    phone?: string;
    country: string;
    address1?: string;
    address2?: string;
    city: string;
    state: string;
    postalCode?: string;
    role: string;
    isTaxExempt?: boolean;
    applyForCredit?: boolean;
    signUpForNewsLetter?: boolean;
    dataShareOptOut?: boolean;
    onSuccess?: () => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<
    RequestAccountParameter,
    RequestAccountApiParameter,
    ServiceResult<RequestAccountModel>
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        account: {
            ...props.parameter,
        } as RequestAccountModel,
    };
};

export const RequestAccount: HandlerType = async props => {
    props.apiResult = await requestAccountApi(props.apiParameter);
};

export const TrackGaRegistration: HandlerType = props => {
    const state = props.getState() as xGoogleAnalyticsState;

    if (state.xGoogleAnalytics.registrationEvent) {
        const dataLayer = getDataLayer();
        if (!dataLayer) {
            return;
        }

        const googleAnalyticsData = {
            event: "registration",
            affiliation: props.parameter.customerNumber,
            company_name: props.parameter.companyName,
            impersonation: trackAsImpersonation(state),
        };
    
        dataLayer.push(googleAnalyticsData);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        // markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
    }
};

export const chain = [PopulateApiParameter, RequestAccount, TrackGaRegistration, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const requestAccount = createHandlerChainRunner(chain, "RequestAccount");
export default requestAccount;
